module.exports = __webpack_public_path__ + "img/marking_bracket_non_wired.d38e0852.png";